module.exports = __webpack_public_path__ + "static/media/ST.4e057c1c.png";